import PropTypes from 'prop-types'
import React from 'react'
import { Page, Page404, PageHeader, AddPageContent } from '../src/ui'
import { connect } from 'react-redux'
import { ActivatePromoCKB } from '../src/modules/users/Profile/components/pages'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import { getUserInfo } from '../src/modules/users/Profile/selectors'
import { fetchAdsWithPromos } from '../src/modules/ads/list/actions'
import { getPaginationParams } from '../src/modules/ads/paginationWithPromos/selectors'
import config from '../src/config/config.yaml'

class ActivatePromoCKBPage extends React.Component {
  static async getInitialProps ({store, req, query}) {
    let { page = 1, phone = '' } = query

    const state = store.getState()

    const user = getUserInfo(state)

    if (!phone && user && Array.isArray(user.phones)) {
      const visiblePhone = user.phones.find(p => p.visible)

      if (visiblePhone) phone = visiblePhone.phone
    }

    if (phone) {
      const paginationParmas = getPaginationParams(state)

      const request = { page: Number(page), phone, limit: paginationParmas.countPerPage }

      await store.dispatch(fetchAdsWithPromos(request))
    }

    console.log('logged user', user)

    let isPageExists = true

    return {
      title: isPageExists ? `Online plaćanje | ${config.siteName}` : config.pages.notFoundTitle,
      isPageExists,
      component: req && req.url ? req.url.endsWith('/app') ? 'activatepromockbapp' : 'activatepromockb' : 'activatepromockb',
      state: ActivatePromoCKBPage.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.currentPage = currentState.user.profile.page
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles

      if (isPageExists) {
        state.user.profile.promo = currentState.user.profile.promo

        state.ads.listings = currentState.ads.listings
      }

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.userTypes = currentState.common.userTypes
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.cities = currentState.geoObjects.cities
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.locations = currentState.geoObjects.locations

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo
      state.categories.withGroups = currentState.categories.withGroups
      state.categories.parentCategories = currentState.categories.parentCategories

      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas

      state.ads.adsWithPromos = currentState.ads.adsWithPromos
      state.ads.adsWithPromosPagination = currentState.ads.adsWithPromosPagination

      state.form = currentState.form
    }
    return state
  }

  render () {
    const {isPageExists, isForApp} = this.props
    return isPageExists ? <Page>
      <PageHeader isForApp={isForApp}>Online plaćanje</PageHeader>
      <AddPageContent
        isForApp={isForApp}
        title='Online plaćanje'
        descriptionClass='heading-lead'
        narrow
        description='Unesite broj telefona i kada vam se prikažu oglasi koje imate izaberite koji želite da promovišete i koliko dana.'
      >
        <ActivatePromoCKB isForApp={isForApp} />
      </AddPageContent>
    </Page>
      : <Page404 />
  }
}

ActivatePromoCKBPage.propTypes = {
  isPageExists: PropTypes.bool.isRequired,
  isForApp: PropTypes.bool.isRequired
}

ActivatePromoCKBPage.defaultProps = {
  isPageExists: false
}

export default connect(null)(ActivatePromoCKBPage)
